export const experiences = [

    {
        id: 1,
        type: 'work',
        title: 'Founder & Web Developer (Freelance)',
        company: 'Escarpment Web Design',
        date: '05/2026 - Present',
        summary: 'taking the leap into freelance, building websites and local SEO solutions for small businesses in Hamilton',
        bullets: [
            'currently building escarpmentwebdesign.com',
            'targeting local restaurants, gyms, trades, and professionals with outdated or missing web presence',
            'focused on clean fast sites with real Google visibility'
        ],
        side: 'left'
    },
    {
        id: 2,
        type: 'work',
        title: 'Software Developer (Co-Op)',
        company: 'Procor Limited',
        date: '04/2025 – 08/2025',
        summary: 'shipped backend features for a fleet management application scheduling 30k+ railway tank cars',
        bullets: [
            'built and tested REST API endpoints consumed by an internal iPad scheduling app',
            'got thrown into a production Java codebase and figured it out',
            'presented end-of-term project to engineering stakeholders across Canadian and US offices'
        ],
        side: 'right'
    },
    {
        id: 3,
        type: 'work',
        title: 'QA Analyst (Co-Op)',
        company: 'Procor Limited',
        date: '01/2024 – 04/2025',
        summary: 'made sure things worked before they went live, phased rollouts and all',
        bullets: [
            'wrote automated API tests in Groovy so humans didn\'t have to',
            'broke things professionally so users wouldn\'t have to',
            'helped migrate legacy ETL pipelines to Apache Kafka for real-time event streaming',
            'built proper onboarding docs in Confluence so the next co-ops didn\'t have to learn from Udemy videos like I did',
        ],
        side: 'left'
    },
    {
        id: 4,
        type: 'work',
        title: 'Personal Banker',
        company: 'Bank of Montreal',
        date: '01/2017 – 06/2022',
        summary: 'helped real people navigate real financial decisions for five years',
        bullets: [
            'helped people make sense of their finances one appointment at a time',
            'five years of keeping calm when the queue was not',
            'consistently met sales targets while keeping the human side of banking intact'

        ],
        side: 'right'
    },
    {
        id: 4,
        type: 'education',
        title: 'Graduated — Mohawk College',
        company: 'Mohawk College',
        date: '12/2025',
        summary: 'completed a long journey and came out the other side',
        bullets: [
            'got the paper to prove it',
            'made some amazing friends along the way',
        ],
        side: 'left'
    },
    {
        id: 5,
        type: 'education',
        title: 'Applied Research Project — AI WWII Aircraft Detection',
        company: 'Mohawk College',
        date: '2025',
        summary: 'spent two semesters teaching a computer to recognize WWII aircraft for the Canadian Warplane Heritage Museum',
        bullets: [
            'scraped and annotated over 1000 images by hand so the model actually knew what it was looking at',
            'ended up with roughly 20% better accuracy than where we started',
            'got a field trip to the museum and  saw in person some of the planes I had been staring at on a screen for months',
        ],
        side: 'right'
    },
    {
        id: 6,
        type: 'education',
        title: 'Software Engineering Project — Intrfac3',
        company: 'Mohawk College',
        date: '2024',
        summary: 'built a dashboard for a startup using React and the Instagram API',
        bullets: [
            'first real taste of React in a client-facing project',
            'integrated Instagram API to pull and display analytics data',
            'set up webhooks to listen for real-time Instagram account updates',
        ],
        side: 'left'
    },
    {
        id: 7,
        type: 'education',
        title: 'Microsoft Azure Fundamentals',
        company: 'Microsoft',
        date: '2023',
        summary: 'earned cloud certification covering core Azure concepts and services',
        bullets: [
            'school paid for it, no complaints',
        ],
        side: 'right'
    },
    {
        id: 8,
        type: 'education',
        title: 'Joined Cybersecurity Club',
        company: 'Mohawk College',
        date: '2023',
        summary: 'got into the world of ethical hacking and security challenges',
        bullets: [
            'played around with Kali Linux',
            'captured a flag in a CTF competition',
        ],
        side: 'left'
    },
    {
        id: 9,
        type: 'education',
        title: 'The Beginning',
        company: 'Mohawk College',
        date: 'Sept 2022',
        summary: 'officially started the software development journey',
        bullets: [
            'I wanted a change in my life and I dove in head first',
            'chose Mohawk specifically for the co-op program as I knew I needed real experience',
        ],
        side: 'right'
    },


    {
        id: 10,
        type: 'hobbies',
        title: 'Learned Salsa & Bachata',
        company: '',
        date: 'Summer 2025',
        summary: 'picked up two latin dances and discovered Salsa on Bayfront',
        bullets: [
            'saw how alive Salsa on Bayfront gets on a summer night',
            'learned something totally out of my character and enjoyed every bit of it',
            'my high school self would be shocked'
        ],
        side: 'left'
    },
    {
        id: 11,
        type: 'hobbies',
        title: 'Ran Around the Bay — 30km',
        company: '',
        date: 'March 2024',
        summary: 'ran 30km around Hamilton Bay and survived (barely)',
        bullets: [
            'felt great for the first 22km',
            'limped the rest of the way in agony',
            'gained a newfound respect for Terry Fox',
        ],
        side: 'right'
    },
    {
        id: 12,
        type: 'hobbies',
        title: 'Bell x Hackworks Hackathon',
        company: 'Bell',
        date: 'Oct 2023',
        summary: 'built a password manager with Next.js in 48 hours to tackle cybersecurity awareness',
        bullets: [
            'first time using Next.js, learned it on the fly under pressure',
            'tackled a real problem: "123456" is still the most common password in 2023',
            'went with my goofy friends, didn\'t win but had a great time',
        ],
        side: 'left'
    },
    {
        id: 13,
        type: 'hobbies',
        title: 'First Trip Back to the Philippines',
        company: '',
        date: 'Summer 2022',
        summary: 'went back home and breathed the air I breathed when I was born',
        bullets: [
            'surfed in Siargao',
            'swam with whale sharks in Cebu',
            'saw how my parents grew up and gained a whole new perspective on life',
        ],
        side: 'right'
    },
]